import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
var lowerAndUpperCasesRegex = /^(?=.*[a-z])(?=.*[A-Z])/;
var atLeastOneNumberRegex = /^(?=.*[0-9])/;
export var genderSchema = yup
    .string()
    .required()
    .oneOf(['male', 'female', 'none']);
var required = fieldValidationMessageIds.required, atLeastOneNumber = fieldValidationMessageIds.atLeastOneNumber, eightOrMoreCharacters = fieldValidationMessageIds.eightOrMoreCharacters, upperAndLowerCaseLetters = fieldValidationMessageIds.upperAndLowerCaseLetters;
export var passwordLengthSchema = yup.string().min(8, eightOrMoreCharacters);
export var passwordLowerAndUpperCaseSchema = yup
    .string()
    .matches(lowerAndUpperCasesRegex, upperAndLowerCaseLetters);
export var passwordAtLeastOneNumberSchema = yup
    .string()
    .matches(atLeastOneNumberRegex, atLeastOneNumber);
export var passwordSchema = yup
    .string()
    .concat(passwordLengthSchema)
    .concat(passwordLowerAndUpperCaseSchema)
    .concat(passwordAtLeastOneNumberSchema)
    .required(required);
export var checkSchema = function (schema, val) {
    try {
        schema.validateSync(val);
        return true;
    }
    catch (_e) {
        return false;
    }
};
